module.exports = __webpack_public_path__ + "img/2.faaa6c3f.png";